"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/Conversation/ComposerActionMenu.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);

var _classBuilder = require('shared/services/classBuilder'); var _classBuilder2 = _interopRequireDefault(_classBuilder);



var _composer = require('shared/services/composer');

// Web glyphs for the registry's platform-neutral icon names.
const ICONS = {
  attach: 'attach_file',
  emoji: 'insert_emoticon',
  templates: 'short_text',
  schedule: 'schedule',
  form: 'assignment',
}
const FALLBACK_ICON = 'more_horiz'

const SECTION_LABELS = {
  insert: 'Insert',
  send: 'Send',
  more: 'More',
}









// Shortcuts still work and are announced (aria-keyshortcuts), but the row
// shows no shortcut label: the people using this aren't keyboard power users.
// Hover only highlights (CSS). It never moves focus: Chrome sends hover
// events to rows that open under a pointer that hasn't moved, which would
// pull focus off the first row.
const MenuRow = _react.memo.call(void 0, ({ action, active, ctx, mac, onPick }) => {
  const { enabled, reason } = _composer.composerActionState.call(void 0, action, ctx)
  const reasonId = _react.useId.call(void 0, )
  const onClick = _react.useCallback.call(void 0, () => {
    if (enabled) onPick(action)
  }, [enabled, onPick, action])

  return (
    _react2.default.createElement('button', {
      type: "button",
      role: "menuitem",
      tabIndex: active ? 0 : -1,
      // Disabled rows stay focusable so their reason is read out.
      'aria-disabled': enabled ? undefined : true,
      'aria-describedby': reason ? reasonId : undefined,
      'aria-keyshortcuts': _optionalChain([action, 'access', _ => _.shortcut, 'optionalAccess', _2 => _2.mod]) ? _composer.shortcutAriaKeys.call(void 0, action.shortcut, mac) : undefined,
      className: _classBuilder2.default.call(void 0, 'composer-menu--item', !enabled && 'composer-menu--item-disabled'),
      onClick: onClick, __self: this, __source: {fileName: _jsxFileName, lineNumber: 46}}

      , _react2.default.createElement('i', { className: "material-icons composer-menu--icon" , 'aria-hidden': true, __self: this, __source: {fileName: _jsxFileName, lineNumber: 57}}, ICONS[action.icon] || FALLBACK_ICON)
      , _react2.default.createElement('span', { className: "composer-menu--label", __self: this, __source: {fileName: _jsxFileName, lineNumber: 58}}, action.label)
      , reason && _react2.default.createElement('span', { id: reasonId, className: "composer-menu--reason", __self: this, __source: {fileName: _jsxFileName, lineNumber: 59}}, reason)
    )
  )
})
MenuRow.displayName = 'MenuRow'














// The V1 popover list: rows grouped by section with roving focus. It mounts
// only while open, so every open starts on the first row.
const ComposerActionMenu = ({ id, actions, ctx, mac, anchor, onPick, onEscape, onDismiss }) => {
  const [active, setActive] = _react.useState.call(void 0, 0)
  const menu = _react.useRef(null)

  _react.useLayoutEffect.call(void 0, () => {
    _optionalChain([menu, 'access', _3 => _3.current, 'optionalAccess', _4 => _4.querySelectorAll, 'call', _5 => _5('[role="menuitem"]'), 'access', _6 => _6[active], 'optionalAccess', _7 => _7.focus, 'call', _8 => _8()])
  }, [active])

  const latest = _react.useRef.call(void 0, { onDismiss, anchor })
  _react.useLayoutEffect.call(void 0, () => {
    latest.current = { onDismiss, anchor }
  })
  _react.useEffect.call(void 0, () => {
    const onMouseDown = (event) => {
      // SAFETY: a mousedown on the document always targets a DOM node.
      const target = event.target 
      if (_optionalChain([menu, 'access', _9 => _9.current, 'optionalAccess', _10 => _10.contains, 'call', _11 => _11(target)]) || _optionalChain([latest, 'access', _12 => _12.current, 'access', _13 => _13.anchor, 'optionalAccess', _14 => _14.contains, 'call', _15 => _15(target)])) return
      latest.current.onDismiss()
    }
    document.addEventListener('mousedown', onMouseDown)
    return () => document.removeEventListener('mousedown', onMouseDown)
  }, [])

  const onKeyDown = _react.useCallback.call(void 0, (e) => {
    const count = actions.length
    if (!count) return
    switch (e.key) {
      case 'ArrowDown':
        e.preventDefault()
        setActive(i => (i + 1) % count)
        return
      case 'ArrowUp':
        e.preventDefault()
        setActive(i => (i - 1 + count) % count)
        return
      case 'Home':
        e.preventDefault()
        setActive(0)
        return
      case 'End':
        e.preventDefault()
        setActive(count - 1)
        return
      case 'Enter':
      case ' ': {
        e.preventDefault()
        const items = Array.from(_optionalChain([menu, 'access', _16 => _16.current, 'optionalAccess', _17 => _17.querySelectorAll, 'call', _18 => _18('[role="menuitem"]')]) || [])
        // SAFETY: key events in the menu come from its elements.
        const action = actions[items.indexOf(e.target )]
        if (action && _composer.composerActionState.call(void 0, action, ctx).enabled) onPick(action)
        return
      }
      case 'Escape':
        e.preventDefault()
        e.stopPropagation()
        onEscape()
        return
      case 'Tab':
        onDismiss()
        return
      default:
        // First letter jumps to the next row starting with it.
        if (e.key.length === 1 && !e.metaKey && !e.ctrlKey && !e.altKey) {
          const letter = e.key.toLowerCase()
          setActive(current => {
            for (let step = 1; step <= count; step++) {
              const candidate = (current + step) % count
              if (actions[candidate].label.toLowerCase().startsWith(letter)) return candidate
            }
            return current
          })
        }
    }
  }, [actions, ctx, onPick, onEscape, onDismiss])

  const sections = (['insert', 'send', 'more'] )
    .map(section => ({ section, rows: actions.filter(action => action.section === section) }))
    .filter(group => group.rows.length > 0)

  return (
    _react2.default.createElement('div', {
      ref: menu,
      id: id,
      role: "menu",
      'aria-label': "More actions" ,
      className: "composer-menu",
      onKeyDown: onKeyDown, __self: this, __source: {fileName: _jsxFileName, lineNumber: 160}}

      , sections.map(({ section, rows }) => (
        _react2.default.createElement('div', { key: section, role: "group", 'aria-label': SECTION_LABELS[section], className: "composer-menu--section", __self: this, __source: {fileName: _jsxFileName, lineNumber: 169}}
          , _react2.default.createElement('div', { className: "composer-menu--heading", 'aria-hidden': true, __self: this, __source: {fileName: _jsxFileName, lineNumber: 170}}, SECTION_LABELS[section])
          , rows.map(action => {
            const index = actions.indexOf(action)
            return (
              _react2.default.createElement(MenuRow, {
                key: action.id,
                action: action,
                active: index === active,
                ctx: ctx,
                mac: mac,
                onPick: onPick, __self: this, __source: {fileName: _jsxFileName, lineNumber: 174}}
              )
            )
          })
        )
      ))
    )
  )
}

exports. default = ComposerActionMenu
